<template>
    <PatientProfile
        :patientId    = "patientInfo.id"
        :name         = "patientInfo.name"
        :birth        = "patientInfo.birth"
        :age          = "patientInfo.age"
        :weight       = "patientInfo.weight"
        :lastExam     = "patientInfo.lastExam"
        :painArea     = "patientInfo.painArea"
        :showPainArea = "false"
    />
    <hr style="border:0; border-top:1.5px solid #c8c8c8; margin:12px 0;" />
    <div class="body-table-row">
        <div class="protocol-page">
            <div class="protocol-bottom-row">
                <button class="protocol-load-btn" @click="openModal('protocolLoaderModal')">불러오기</button>
                <button class="protocol-btn" @click="resetAll">초기화</button>
                <button class="protocol-btn-primary" :disabled="!saveEnabled" @click="saveAll">저장</button>
            </div>
            <div class="protocol-title-bar">
                <div class="protocol-title-line">
                    <div class="protocol-title">
                        프로토콜 명 :
                        <input class="protocol-name-input" type="text" placeholder="ex. protocol A" v-model="protocolName" />
                        <!-- 질환명 :
                        <div class="custom-select">
                            <select v-model="selectedProtocol">
                                <option value="">선택</option>
                                <option value="1">급성요통</option>
                                <option value="2">섬유근육통</option>
                                <option value="3">중추성통증</option>
                                <option value="4">말초신경병증</option>
                            </select>
                        </div> -->
                    </div>
                    <div class="protocol-title"></div>
                    <label class="protocol-checkbox-label">
                        <input type="checkbox" v-model="pairRandom" />
                        Pair 순서 랜덤 설정
                    </label>
                </div>
            </div>
            <!-- 본문 표 영역 -->
            <div class="protocol-content-row">
                <!-- 왼쪽 테이블 -->
                <table class="protocol-table">
                    <colgroup>
                        <col style="width: 5%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 5%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Pair</th>
                            <th>F1(Hz)</th>
                            <th>I(μA)</th>
                            <th>T(m'm)</th>
                            <th>Period(ms)</th>
                            <th>Polarity</th>
                            <th>Wave-Form</th>
                            <th>삭제</th>
                        </tr>
                    </thead>
                    <draggable v-model="leftTable" tag="tbody" :item-key="(item, index) => index" animation="200" :disabled="true">
                        <template #item="{ element, index }">
                            <tr :key="index">
                                <td>{{ index + 1 }}</td>
                                <td><input class="protocol-input" v-model="element.freqHz"   type="number" v-number-range="[1, 1000]"/></td>
                                <td><input class="protocol-input" v-model="element.ampUa"    type="number" v-number-range="[30, 1000]"/></td>
                                <td><input class="protocol-input" v-model="element.tMs"      type="number" @input="syncTToOtherTable(index, 'left', $event.target.value)" v-number-range="[1, 99999]" /></td>
                                <td><input class="protocol-input" v-model="element.periodMs" type="number" v-number-range="[500, 5000]" @blur="onPeriodBlur(element)"/></td>
                                <td>
                                    <div class="protocol-custom-select">
                                        <select v-model="element.polarity">
                                            <option disabled value="">선택</option>
                                            <option value="1">+방향</option>
                                            <option value="2">-방향</option>
                                            <option value="3">양방향</option>
                                        </select>
                                    </div>
                                </td>
                                <td>
                                    <div class="protocol-custom-select">
                                        <select v-model="element.waveForm">
                                            <option disabled value="">선택</option>
                                            <option value="Sharp">Sharp</option>
                                            <option value="Moderate">Moderate</option>
                                            <option value="Triangle">Triangle</option>
                                            <option value="Square">Square</option>
                                            <option value="Sawtooth">Sawtooth</option>
                                            <option value="Fast Ramp-Up">Fast Ramp-Up</option>
                                            <option value="Short-Pulse">Short-Pulse</option>
                                            <option value="Default-Wave">Default-Wave</option>
                                        </select>
                                    </div>
                                </td>
                                <td>
                                    <button class="protocol-delete" @click="confirmAndRemoveRow('Ch1', index)">
                                        <img class="icon" src="@/assets/resource/icon/trash.png" alt="delete" style="width: 20px; height: auto;"/>
                                    </button>
                                </td>
                            </tr>
                        </template>
                    </draggable>
                </table>
                <!-- 오른쪽 테이블 -->
                <table class="protocol-table">
                    <colgroup>
                        <col style="width: 5%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 5%" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Pair</th>
                            <th>F2(Hz)</th>
                            <th>I(μA)</th>
                            <th>T(m'm)</th>
                            <th>Period(ms)</th>
                            <th>Polarity</th>
                            <th>Wave-Form</th>
                            <th>삭제</th>
                        </tr>
                    </thead>
                    <draggable v-model="rightTable" tag="tbody" :item-key="(item, index) => index" animation="200" :disabled="true">
                        <template #item="{ element, index }">
                            <tr :key="index">
                                <td>{{ index + 1 }}</td>
                                <td><input class="protocol-input" v-model="element.freqHz"   type="number" v-number-range="[1, 1000]"/></td>
                                <td><input class="protocol-input" v-model="element.ampUa"    type="number" v-number-range="[30, 1000]"/></td>
                                <td><input class="protocol-input" v-model="element.tMs"      type="number" @input="syncTToOtherTable(index, 'right', $event.target.value)" v-number-range="[1, 99999]"/></td>
                                <td><input class="protocol-input" v-model="element.periodMs" type="number" v-number-range="[500, 5000]" @blur="onPeriodBlur(element)"/></td>
                                <td>
                                    <div class="protocol-custom-select">
                                        <select v-model="element.polarity">
                                            <option disabled value="">선택</option>
                                            <option value="1">+방향</option>
                                            <option value="2">-방향</option>
                                            <option value="3">양방향</option>
                                        </select>
                                    </div>
                                </td>
                                <td>
                                    <div class="protocol-custom-select">
                                        <select v-model="element.waveForm">
                                            <option disabled value="">선택</option>
                                            <option value="Sharp">Sharp</option>
                                            <option value="Moderate">Moderate</option>
                                            <option value="Triangle">Triangle</option>
                                            <option value="Square">Square</option>
                                            <option value="Sawtooth">Sawtooth</option>
                                            <option value="Fast Ramp-Up">Fast Ramp-Up</option>
                                            <option value="Short-Pulse">Short-Pulse</option>
                                            <option value="Default-Wave">Default-Wave</option>
                                        </select>
                                    </div>
                                </td>
                                <td>
                                    <button class="protocol-delete" @click="confirmAndRemoveRow('Ch2', index)">
                                        <img class="icon" src="@/assets/resource/icon/trash.png" alt="delete" style="width: 20px; height: auto;"/>
                                    </button>
                                </td>
                            </tr>
                        </template>
                    </draggable>
                </table>
            </div>
            <!-- 하단 버튼 -->
            <div class="protocol-bottom-row">
                <button class="protocol-btn-primary" @click="openModal('protocolLoaderModal')">불러오기</button>
                <button class="protocol-btn" @click="resetAll">초기화</button>
                <button class="protocol-btn-primary" :disabled="!saveEnabled" @click="saveAll">저장</button>
            </div>
        </div>
    </div>
</template>
<script setup>
    import router from "@/router";

    defineOptions({
        meta: {
            title: '통증 케어 프로토콜 등록',
            segmentKey: 'patientId'
        }
    })

    import {useRoute}                           from "vue-router";
    import {onMounted, ref, computed, watch, onUnmounted, nextTick }   from "vue";
    import api, {urls}                          from "@/api";
    import PatientProfile                       from "@/components/common/PatientProfile.vue";
    import draggable                            from 'vuedraggable';
    import { commonUtils }                      from "@/utils/commonUtils";
    import { useModal }                         from "@/composables/useModal";
    import { useAppAlert }                      from '@/composables/useAppAlert'

    const { showAlert, confirm }      = useAppAlert()
    const { openModal, onModalEvent } = useModal()

    const route          = useRoute()
    const patientInfo    = ref({})
    const protocolName   = ref('');
    const pairRandom     = ref(false)

    const emptyRow = () => ({
        freqHz   : '',
        ampUa    : '',
        tMs      : '',
        periodMs : '',
        polarity : '',
        waveForm : ''
    });

    const leftTable   = ref(Array.from({length: 20}, emptyRow));
    const leftEditIdx = ref(null);       // 몇 번째 행 수정모드인지
    const leftEditRow = ref({});         // 수정 row 데이터

    const rightTable   = ref(Array.from({length: 20}, emptyRow));
    const rightEditIdx = ref(null);       // 몇 번째 행 수정모드인지
    const rightEditRow = ref({});         // 수정 row 데이터

    const selectedProtocol           = ref('');   // select 선택값
    const searchTerm                 = ref('');   // 검색어 input
    const isLoaded                   = ref(false);
    const originalLoadedProtocolName = ref('');

    const idFromRoute = ref(null)
    const diagnosisId = ref(null)

    const hasAnyValue = computed(() => {
        // 좌측 테이블과 우측 테이블을 모두 확인
        const checkTable = (table) =>
            table.some(row =>
                (row.freqHz || '').toString().trim() !== '' ||
                (row.ampUa || '').toString().trim() !== '' ||
                (row.tMs || '').toString().trim() !== '' ||
                (row.periodMs || '').toString().trim() !== '' ||
                (row.polarity || '').toString().trim() !== '' ||
                (row.waveForm || '').toString().trim() !== ''
            );
        return checkTable(leftTable.value) || checkTable(rightTable.value);
    });

    const saveEnabled = computed(() => {
        return hasAnyValue.value;
    });

    const incompleteRowsExist = computed(() => {
        const checkRow = (row) => {
            const values = [row.freqHz, row.ampUa, row.tMs, row.periodMs, row.polarity,row.waveForm].map(v =>
                (v ?? '').toString().trim()
            );
            const hasValue = values.some(v => v !== '');
            const hasEmpty = values.some(v => v === '');
            return hasValue && hasEmpty; // 일부만 채워진 경우
        };
        const checkTable = (table) => table.some(checkRow);
        return checkTable(leftTable.value) || checkTable(rightTable.value);
    });

    async function resetAll() {
        if (!(await confirm('정말로 초기화하시겠습니까?'))) return;
        
        // 검색어, 선택값 초기화 (필요시)
        searchTerm.value        = '';
        selectedProtocol.value  = '';

        // 프로토콜명 빈값으로 초기화
        protocolName.value = '';

        // 좌우 테이블 빈값으로 초기화
        leftTable.value  = Array.from({length: 20}, emptyRow);
        rightTable.value = Array.from({length: 20}, emptyRow);

        // 통증부위 선택 초기화 추가
        selectedFront.value = [];

        // 편집 상태 초기화
        leftEditIdx.value  = null;
        leftEditRow.value  = {};
        rightEditIdx.value = null;
        rightEditRow.value = {};

        isLoaded.value = false;
    }

    async function PatientData(id, diagnosisId) {
        try {
            const params = {
                id: id,
                diagnosisId: diagnosisId
            };

            const res  = await api.post(urls.patientList.patientData, params);
            const data = res.data.list ? res.data.list[0] : res.data;

            // [1] 환자 프로필용 데이터
            patientInfo.value = {
                id       : data.patient_id,
                name     : data.name,
                birth    : data.dob || '',
                age      : commonUtils.calcAge(data.dob),
                weight   : data.weight,
                lastExam : data.created_at ? data.created_at.split('T')[0] : '',
                painArea : ''
            };
        } catch (err) {
            showAlert("환자 정보 불러오는데 실패했습니다.");
        }
    }

    function toFloat(value) {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    }

    // 메인 저장 함수
    async function saveAll() {
        if (!validateRows()) return;
        if (!checkTimeLimits()) return;
        if (!(await(confirm('정말로 저장하시겠습니까?')))) return;

        const payloads = createPayloads();
        const saveType = isLoaded.value ? 'fromLoad' : 'new';

        await saveProtocol(payloads, saveType);
    }

    // 입력값 각 행 유효성 검사
    function validateRows() {
        if (incompleteRowsExist.value) {
            showAlert('입력되지 않은 항목이 있는 행이 있습니다. 모든 항목을 채우시거나 빈 행으로 유지해 주세요.');
            return false;
        }
        return true;
    }

    // 시간 제한 검사
    function checkTimeLimits() {
        const maxPairTimeMs  = 20 * 60;
        const maxTotalTimeMs = 60 * 60;
        
        let totalTimeMs = 0;
        
        const overLimitPairs = [];

        // leftTable만 검사 (pair1 기준)
        leftTable.value.forEach((row, idx) => {
            if (row.tMs) {
                const tMsValue = parseFloat(row.tMs);
                if (isNaN(tMsValue)) return;
                if (tMsValue > maxPairTimeMs) {
                    overLimitPairs.push({
                        channel  : 'Ch1',
                        pairNo   : idx + 1,
                        excessMs : Math.ceil(tMsValue - maxPairTimeMs)
                    });
                }
                totalTimeMs += tMsValue;
            }
        });

        if (overLimitPairs.length > 0) {
            let message = `1 pair당 지속 시간이 최대 20분(1200 ms)을 초과했습니다.\n\n`;
            overLimitPairs.forEach(({channel, pairNo, excessMs}) => {
                message += `채널: ${channel}, 페어 번호: ${pairNo}, 초과량: ${excessMs} ms\n`;
            });
            showAlert(message);
            return false;
        }
        if (totalTimeMs > maxTotalTimeMs) {
            const excessRounded = Math.ceil(totalTimeMs - maxTotalTimeMs);
            showAlert(
                `전체 pair 시간 합계가 최대 60분(3600 ms)을 초과했습니다.\n초과량: ${excessRounded} ms`
            );
            return false;
        }
        return true;
    }

    // API에 전달할 데이터 payload 생성
    function createPayloads() {
        const payloads    = [];
        const randomFlag  = pairRandom.value ? 1 : 0;
        const protocolMap = {
            '1': '급성요통',
            '2': '섬유근육통',
            '3': '중추성통증',
            '4': '말초신경병증',
        };
        const painAreaStr = protocolMap[selectedProtocol.value] || '';

        // 좌/우 테이블
        leftTable.value.forEach((row, idx) => {
            if (row.freqHz || row.ampUa || row.tMs || row.periodMs || row.polarity || row.waveForm) {
                payloads.push({
                    protocolName : protocolName.value,
                    pairNo       : idx + 1,
                    channel      : 'Ch1',
                    freqHz       : toFloat(row.freqHz),
                    ampUa        : toFloat(row.ampUa),
                    tMs          : toFloat(row.tMs) * 60, // 초 단위 -> 뷴 단위 변환
                    periodMs     : toFloat(row.periodMs),
                    polarity     : row.polarity || '',
                    waveForm     : row.waveForm || '',
                    pairRandom   : randomFlag,
                    painArea     : painAreaStr
                });
            }
        });
        rightTable.value.forEach((row, idx) => {
            if (row.freqHz || row.ampUa || row.tMs || row.periodMs || row.polarity || row.waveForm) {
                payloads.push({
                    protocolName : protocolName.value,
                    pairNo       : idx + 1,
                    channel      : 'Ch2',
                    freqHz       : toFloat(row.freqHz),
                    ampUa        : toFloat(row.ampUa),
                    tMs          : toFloat(row.tMs) * 60, // 초 단위 -> 뷴 단위 변환
                    periodMs     : toFloat(row.periodMs),
                    polarity     : row.polarity || '',
                    waveForm     : row.waveForm || '',
                    pairRandom   : randomFlag,
                    painArea     : painAreaStr
                });
            }
        });
        return payloads;
    }

    // 저장 로직 분기(불러오기/신규입력)
    async function saveProtocol(payloads, saveType) {
        const requestData = {
            patientId   : idFromRoute.value,
            diagnosisId : diagnosisId.value,
            protocols   : payloads,
        };

        if (saveType === 'new') {
            // 1. protocol_pairs 이름 중복 체크
            const nameCheck = await api.get(urls.protocol.checkName, {params: { name: protocolName.value }});
            if (nameCheck.data.exists) {
                showAlert('프로토콜 명이 중복됩니다. 다른 이름을 입력하세요.');
                return;
            }
            await api.post(urls.protocol.savePairs, requestData);
        } else {
            if (protocolName.value !== originalLoadedProtocolName.value) {
                const nameCheck = await api.get(urls.protocol.checkName, {params: { name: protocolName.value }});
                if (nameCheck.data.exists) {
                    showAlert('프로토콜 명이 중복됩니다. 다른 이름을 입력하세요.');
                    return;
                }
            }
        }
        await api.post(urls.protocol.save, requestData)
            .then(res => {
                if (res.data >= 1) showAlert('프로토콜이 저장되었습니다.');
                else showAlert(`저장 실패 (코드: ${res.data})`);
            })
            .catch(err => {
                showAlert('저장 중 오류가 발생했습니다.');
            });
        router.push({
            path: `/patientlist/prescriptionHistory/${route.params.patientId}`
        })
    }

    function applyProtocolData(dataList) {
        // 테이블 초기화 (20개 행 모두 빈값)
        leftTable.value  = Array.from({length: 20}, () => ({freqHz: '', ampUa: '', tMs: '', periodMs: '', Polarity: '',waveForm:''}));
        rightTable.value = Array.from({length: 20}, () => ({freqHz: '', ampUa: '', tMs: '', periodMs: '', Polarity: '',waveForm:''}));

        dataList.forEach(item => {
            const idx = item.pairNo - 1; // pairNo가 1~20, 배열은 0~19
            if (item.channel === 'Ch1') {
                leftTable.value[idx] = {
                    freqHz   : item.freqHz?.toString() || '',
                    ampUa    : item.ampUa?.toString() || '',
                    tMs      : item.tMs ? Math.ceil(parseFloat(item.tMs) / 60).toString() : '',  // 초 -> 분 변환
                    periodMs : item.periodMs?.toString() || '',
                    polarity : item.polarity || '',
                    waveForm : item.waveForm || ''
                };
            } else if (item.channel === 'Ch2') {
                rightTable.value[idx] = {
                    freqHz   : item.freqHz?.toString() || '',
                    ampUa    : item.ampUa?.toString() || '',
                    tMs      : item.tMs ? Math.ceil(parseFloat(item.tMs) / 60).toString() : '',  // 초 -> 분 변환
                    periodMs : item.periodMs?.toString() || '',
                    polarity : item.polarity || '',
                    waveForm : item.waveForm || ''
                };
            }
        });
    }

    function confirmAndRemoveRow(channel, index) {
        if (confirm(`${channel} 채널의 페어 #${index + 1}을(를) 정말 삭제하시겠습니까?`)) {
            if (channel === 'Ch1') {
                leftTable.value.splice(index, 1);
                leftTable.value.push(emptyRow());
            } else if (channel === 'Ch2') {
                rightTable.value.splice(index, 1);
                rightTable.value.push(emptyRow());
            }
        }
    }

    function onApplySelected(dataList) {
        applyProtocolData(dataList);

        if (dataList.length > 0) {
            protocolName.value = dataList[0].protocolName || '';
            pairRandom.value = !!dataList[0].pairRandom;
            originalLoadedProtocolName.value = dataList[0].protocolName || '';

            const protocolMap = {
                '1': '급성요통',
                '2': '섬유근육통',
                '3': '중추성통증',
                '4': '말초신경병증',
            };
            const reverseMap = Object.entries(protocolMap).reduce((acc, [key, val]) => {
                acc[val] = key;
                return acc;
            }, {});

            if (dataList[0].painArea && reverseMap[dataList[0].painArea]) {
                selectedProtocol.value = reverseMap[dataList[0].painArea];
            } else {
                selectedProtocol.value = '';
            }

            patientInfo.value.painArea = dataList[0].painArea || '';
            isLoaded.value = true;
        } else {
            protocolName.value               = '';
            pairRandom.value                 = false;
            originalLoadedProtocolName.value = '';
            selectedProtocol.value           = '';
            patientInfo.value.painArea       = '';
            isLoaded.value                   = false;
        }
    }

    function syncTToOtherTable(index, side, value) {
        if (side === 'left') {
            // 좌측에서 입력하면 우측도 같은 값 넣기
            if (rightTable.value[index]) {
                rightTable.value[index].tMs = value;
            }
        } else if (side === 'right') {
            // 우측에서 입력하면 좌측도 같은 값 넣기
            if (leftTable.value[index]) {
                leftTable.value[index].tMs = value;
            }
        }
    }

    const selectedFront = ref([])

    const getData = (data) => {
        if(data){
            onApplySelected(data)
        }
    }

    const maxPairTimeMs  = 20 * 60; // 1200 ms
    const maxTotalTimeMs = 60 * 60; // 1800 ms

    // pair1만 계산
    const pair1TotalTime = computed(() =>
        leftTable.value
            .map(row => parseFloat(row.tMs) || 0)
            .reduce((sum, v) => sum + v, 0)
    );

    // 초과한 row 리스트
    const overLimitPairs = computed(() =>
        leftTable.value
            .map((row, idx) => {
                const t = parseFloat(row.tMs);
                if (!isNaN(t) && t > maxPairTimeMs) {
                    return { pairNo: idx + 1, excessMs: Math.ceil(t - maxPairTimeMs) };
                }
                return null;
            })
            .filter(Boolean)
    );

    const isTotalTimeOver = computed(() => pair1TotalTime.value > maxTotalTimeMs);

    function onPeriodBlur(row) {
        const v = (row.periodMs ?? '').toString().trim()

        // 아무 것도 안 썼거나 빈 문자열이면 2500으로 세팅
        if (v === '') {
            row.periodMs = 2500
        }
    }

    watch([pair1TotalTime, overLimitPairs, isTotalTimeOver], ([total, pairs, over]) => {
        if (pairs.length > 0) {
            showAlert(
                `1 pair당 최대 20분(1200 ms) 초과:\n` +
                pairs.map(pair => `#${pair.pairNo} (초과: ${pair.excessMs} ms)`).join("\n")
            );
        } else if (over) {
            showAlert(
                `전체 pair 시간 합계가 최대 60분(3600 ms)을 초과했습니다.\n합계: ${total} ms`
            );
        }
    });

    onMounted(async () => {

        idFromRoute.value = route.params.patientId
        diagnosisId.value = route.query.diagnosisId
        // 초기 데이터 호출 등
        PatientData(idFromRoute.value, diagnosisId.value)
        onModalEvent('protocolLoaderModal', 'onSubmit', getData)

        await nextTick();
    });
</script>
